module.exports = __webpack_public_path__ + "static/media/eraser.3f674cad.svg";